export const loginAction =
  (token, id, name, email, image, user_type) => (dispatch) => {
    dispatch({
      type: "Login",
      payload: {
        token,
        id,
        name,
        email,
        image,
        user_type,
      },
    });
  };

export const logoutAction = () => async (dispatch) => {
  dispatch({
    type: "Logout",
  });
};

export const setAuthorized = (authCheck) => async (dispatch) => {
  dispatch({
    type: "isAuthorized",
    payload: authCheck,
  });
};

export const loadingAction = (isLoading) => (dispatch) => {
  if (isLoading) {
    dispatch({
      type: "LoadingOn",
    });
  } else {
    dispatch({
      type: "LoadingOff",
    });
  }
};

export const loadingBtnAction = (isLoading) => (dispatch) => {
  if (isLoading) {
    dispatch({
      type: "LoadingBtnOn",
    });
  } else {
    dispatch({
      type: "LoadingBtnOff",
    });
  }
};

export const setUserEmail = (email) => async (dispatch) => {
  dispatch({
    type: "resetPassword",
    payload: email,
  });
};

export const setActiveStep = (step) => async (dispatch) => {
  dispatch({
    type: "activeStep",
    payload: step,
  });
};
